import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import scanLottie from './LottieClerkLoading.json';

const MatchLottieLoading: React.FC = () => {
  return (
    <div className="w-30 h-30 flex justify-center items-center">
      <Lottie
        animationData={scanLottie}
        loop={true}
        style={{ height: 160, width: 160 }}
      />
    </div>
  );
};

export default MatchLottieLoading;
